/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description EditLocation as Link
 */
import { Button, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { Edit } from '@icon-park/react';

import { getEditLocationPath } from 'utils/router';
import { useAppStoreValues } from 'store/app';
import AccessControl from '../AccessControl';

/**
 * EditLocation Link
 * @param props
 */
const EditLocationLink: React.FC<ILinkProps> = (props) => {
	const { children, id, ...restProps } = props;

	return (
		<Link {...restProps} to={getEditLocationPath(id)}>
			{children}
		</Link>
	);
};

/**
 * EditLocation
 *
 */
const EditLocation: React.FC<Record<'details', Location.IModel>> = ({ details }) => {
	const locationID = details?.id;
	const { canEditLocations } = useAppStoreValues().userAccess;
	const editButton = (
		<AccessControl permission='canEditLocations'>
			<Tooltip title='Edit Location'>
				<Button color='default' icon={<Edit />} />
			</Tooltip>
		</AccessControl>
	);

	if (locationID && canEditLocations) {
		return (
			<EditLocationLink key='edit-location' id={locationID}>
				{editButton}
			</EditLocationLink>
		);
	}

	return editButton;
};

export { EditLocationLink };
export default EditLocation;
